import axios from "axios";
import getToken from "../../../config/getToken";
import { convertFileToBase64Dynamic } from "../../../utils/functions";
import { env } from "../../../env";

axios.interceptors.response.use(
  (response) => {
    if (response.data.responseCode === 1016 || response.status === 403) {
      sessionStorage.clear();
      localStorage.clear();
      window.location.href = "/";
    } else {
      return response;
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

/**
 * Petición que carga una lista de credenciales
 * @param {*} data información de la carga
 * @returns respuesta de carga
 */
export async function UploadCredentialsFile(data) {
  const token = await getToken();
  const { fileContent } = data;

  const formData = new FormData();

  formData.append("file", fileContent);

  const finalData = await convertFileToBase64Dynamic(formData, data);

  return axios({
    method: "POST",
    data: finalData,
    url: "masters/uploadCredentials",
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function GetCredentials(mainUser) {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `infonavitcredentials/list/${mainUser}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function CreateCredential(data) {
  const token = await getToken();
  return axios({
    method: "POST",
    url: "infonavitcredentials",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function UpdateCredential(data) {
  const token = await getToken();
  return axios({
    method: "PUT",
    url: "infonavitcredentials",
    data: data,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function GetCredentialsNrps(mainUser) {
  const token = await getToken();
  return axios({
    method: "GET",
    url: `credentialsnrps/list/${mainUser}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}

export async function DeleteCredential(mainUser, rfc) {
  const token = await getToken();
  return axios({
    method: "DELETE",
    url: `infonavitcredentials/${mainUser}/${rfc}`,
    baseURL: env.REACT_APP_API_URL,
    validateStatus: null,
    headers: {
      Authorization: token,
    },
  });
}
